<template>
  <div class="index-three-order-activity">
    <div class="activity-title">
      <div class="title">新用户专享 三单挑战</div>
      <div class="coundown-timer">
        <count-down-timer :init-left-time="fullOrderActivity.remaining_seconds"></count-down-timer>
      </div>
    </div>
    <div class="activity-content">
      <div class="coupon-list" :style="{opacity: ShowCoupon ? 1 : 0}">
        <coupon-three-order-item 
          class="coupon-item"
          v-for="(coupon, index) in fullOrderActivity.coupon_list" 
          :index="index"
          :current="index === fullOrderActivity.last_threshold_num"
          :coupon="coupon"
          :key="index">
        </coupon-three-order-item>
      </div>
      <div class="equity-content">
        <div class="equity-title">完成3单后解锁更多权益</div>  
        <div class="equity-list">
          <div class="equity-item" v-for="(equity, ind) in equityList" :key="ind">
            <div class="equity-img">
              <img :src="equity.icon" alt="">
            </div>
            <!-- <div class="equity-name">
              {{ equity.name }}
            </div> -->
            <div class="equity-label">{{ equity.label }}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
import countDownTimer from '../../../components/activity/count-down-timer.vue';
import couponThreeOrderItem from '@/components/activity/coupon-item/coupon-three-order-item.vue';

export default {
  components: {
    countDownTimer,
    couponThreeOrderItem,
  },
  props: {
    fullOrderActivity: Object,
    ShowCoupon: Boolean,
  },
  data() {
    return {
      equityList: [
        {
          icon: require('../../../assets/imgs/activity/three-order-activity/index-equity-coupon.png'),
          name: '权益一',
          label: '超级券包',
        },
        {
          icon: require('../../../assets/imgs/activity/three-order-activity/index-equity-package.png'),
          name: '权益二',
          label: '满额立减',
        },
        {
          icon: require('../../../assets/imgs/activity/three-order-activity/index-equity-person.png'),
          name: '权益三',
          label: '超级券包',
        },
      ],
    };
  },
  computed: {
  },
  created() {
    // 判断是否还有更多权益----目前只有权益一和二
    if (this.fullOrderActivity && this.fullOrderActivity.next_activity_record_id) {
      this.equityList = this.equityList.slice(0, 2);
    } else {
      this.equityList = this.equityList.slice(0, 1);
    }
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.index-three-order-activity {
  width: 1120px;
  margin: 0 auto;
  margin-bottom: 48px;
  .activity-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-size: 28px;
      color: #2F333D;
      line-height: 40px;
      font-weight: 600;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 4px;
        width: 96px;
        height: 8px;
        background: linear-gradient(270deg, rgba(255,75,75,0) 25%, #FF4B4B 100%);
        opacity: 0.6;
      }
    }
  }
  .activity-content {
    margin-top: 16px;
    background: linear-gradient( 180deg, rgba(255,75,75,0.65) 0%, rgba(255,75,75,0.35) 100%);
    border-radius: 4px;
    // font-size: 18px;
    padding: 20px 34px 16px 34px;
    display: flex;
    justify-content: space-between;
    .coupon-list {
      flex: 2;
      display: flex;
      .coupon-item {
        margin-left: 20px;
        &:first-child {
          margin-left: 0;
        }
      }
    }
    .equity-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: stretch;
      margin-top: 12px;
      .equity-title {
        color: #FFFFFF;
        line-height: 25px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        &::before, &::after {
          content: '';
          display: inline-block;
          width: 36px;
          height: 1px;
          background: #FFFFFF;
        }
        &::before {
          margin-right: 16px;
        }
        &::after {
          margin-left: 16px;
        }
      }
      .equity-list {
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        .equity-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-left: 54px;
          &:first-child {
            margin-left: 0;
          }
          .equity-img {
            width: 60px;
            height: 60px;
            background: rgba(116, 0, 0, .15);
            box-shadow: 0px 4px 9px 0px rgba(47,51,61,0.06);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            >img{
              width: 32px;
              height: 32px; 
            }
          }
          .equity-name {
            margin-top: 10px;
            color: #FFFFFF;
            text-align: center;
            font-size: 14px;
            text-shadow: 0px 2px 2px #E19696;
          }
          .equity-label {
            margin-top: 14px;
            background: #FF6464;
            text-shadow: 0px 2px 2px #E19696;
            border-radius: 12px;
            padding: 4px 8px;
            color: #fff;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/components/index-three-order-activity.vue